import { defineElement, html, TemplateElement, toString } from '@webtides/element-js';
import LastProductCookie from '../../../js/cookies/last-products';
import ProductSliderEvents from './ProductSliderEvents';

class ProductSlider extends TemplateElement {
    lastProducts = [];

    constructor() {
        super({ shadowRenderer: false, deferUpdate: true });
    }

    properties() {
        return {
            url: '/.rest/product/slider/',
            config: {},
            productCards: null,
            cookieMode: false,
            noProductsHint: '',
        };
    }

    async connected() {
        try {
            const { productCards, cookieMode } = await this.fetchProducts();
            this.productCards = productCards;
            this.cookieMode = cookieMode;

            if (cookieMode) {
                LastProductCookie.removeMissingProductSlugFromCookie(this.productCards);
                this.lastProducts = LastProductCookie.get();
            }
        } catch (e) {
            console.log(e);
        }
    }

    async fetchProducts() {
        const response = await fetch(this.url);
        if (!response.ok) throw Error('fetch failed.');
        let data = await response.json();

        this.dispatch(ProductSliderEvents.PRODUCT_LOADED, data, true);

        return data;
    }

    events() {
        return {
            '[ref=prev]': { click: () => this.$refs.slider.prev() },
            '[ref=next]': { click: () => this.$refs.slider.next() },
        };
    }

    get showSpacerElement() {
        return this.productCards.some(productCard => {
            return Object.keys(productCard.frames).some(frame => productCard.frames[frame].price?.discount ?? false);
        });
    }

    templateProductCard(product, { frame = false, color = false } = {}) {
        return html`
            <product-card
                class="block w-full"
                frames="${toString(product.frames)}"
                name="${product.name}"
                current-frame-id="${frame ?? false}"
                has-frame-selector="${product.hasFrameFilter}"
                active-color-key="${color ?? false}"
                description="${product.description}"
                show-spacer-element="${this.showSpacerElement}"
            >
            </product-card>
        `;
    }

    template() {
        if (this.productCards?.length === 0) return html` <div class="text-center">${this.noProductsHint}</div> `;
        return html`
            <glide-element
                ref="slider"
                bullets="true"
                arrows="false"
                class="mt-6 block"
                ref="glide"
                options="${toString(this.config)}"
            >
                ${this.productCards.map(
                    productCard =>
                        html`${this.templateProductCard(
                            productCard,
                            LastProductCookie.get(productCard.productGroupSlug)
                        )}`
                )}
            </glide-element>
        `;
    }
}

defineElement('product-slider', ProductSlider);
